import Info from './info';
import Stomp from './stomp';

export const info = new Info();
export const stomp = new Stomp();

const clientModels = {
  info,
  stomp,
};
(window as any).$cm = clientModels;

export default clientModels;
